import { Link } from "react-router-dom";
import { categoryEntries } from "@/mocks/site";

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {categoryEntries.map((entry, i) => (
        <Link
          key={entry.label}
          to={entry.to}
          className="group flex cursor-pointer items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50/60 md:p-5"
        >
          <span
            className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-md text-xl ${
              i % 3 === 1
                ? "bg-accent-100 text-accent-700"
                : i % 3 === 2
                  ? "bg-secondary-100 text-secondary-700"
                  : "bg-primary-100 text-primary-600"
            }`}
          >
            <i className={entry.icon}></i>
          </span>
          <div className="flex flex-1 flex-col">
            <span className="text-base font-semibold text-foreground-950 group-hover:text-primary-600">
              {entry.label}
            </span>
            <span className="text-xs text-foreground-600">{entry.desc}</span>
          </div>
          <i className="ri-arrow-right-line text-foreground-400 transition-transform group-hover:translate-x-1 group-hover:text-primary-500"></i>
        </Link>
      ))}
    </div>
  );
}